import { makeStyles } from '@material-ui/core/styles'

const useStyle = makeStyles(theme => ({
  root: {
    width: 'auto',
    display: 'flex',
    position: 'relative',
    cursor: 'pointer',

    '& .rv-xy-plot__axis__tick__line': {
      display: 'none'
    }
  },
  graphTitle: {
    transform: 'translate(15px, 135px) rotate(-90deg)',
    height: 'fit-content',
    whiteSpace: 'nowrap',
    width: '3%',
    color: '#6F6F6F',
    fontSize: '12px'
  },
  crossHair: {
    zIndex: 2,
    position: 'absolute',
    top: 0,

    '& .rv-crosshair__line': {
      background: 'rgba(123, 135, 147, 0.3)',
      width: '2px',

      '&::before': {
        content: "",
        position: 'absolute',
        top: 0,
        left: '-6px',
        borderColor: '#f7f8fc transparent transparent',
        borderStyle: 'solid',
        borderWidth: '8px 6px 0',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        top: 0,
        left: '-6px',
        borderColor: 'transparent transparent #f7f8fc',
        borderStyle: 'solid',
        borderWidth: '0 6px 8px',
        filter: 'drop-shadow(0 0 1px #9d9d9d)'
      }
    },

    '& .rv-crosshair__inner': {
      marginRight: '2px',
      zIndex: 2,

      '&::before': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-5px',
        borderColor: 'transparent transparent transparent #d5dadd',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      },

      '&::after': {
        content: "",
        position: 'absolute',
        top: '10px',
        right: '-4px',
        borderColor: 'transparent transparent transparent #ffffff',
        borderStyle: 'solid',
        borderWidth: '5px 0 5px 5px'
      }
    },
  },
  customBox: {
    position: 'absolute',
    top: 0,
    left: '10px',
    background: '#FFFFFF',
    boxShadow: '0px 2px 10px #3f434714',
    padding: '4px',
    color: 'rgb(161, 170, 179)',
    width: 'max-content',

    '& p': {
      fontSize: '12px'
    },

    '& span': {
      fontWeight: 'bold'
    }
  }
}))

export { useStyle }